// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jc-L","type":"styles_type__uAVzh","choices":"styles_choices__2oO7l"};